import { useMutation } from '@apollo/client'

import { CreateInvoiceLineItemDocument } from '@/graphql/purchase-plus/generated/createInvoiceLineItem.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'

export function useCreateInvoiceLineItem() {
  const mutation = useMutation(CreateInvoiceLineItemDocument, {
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
  })

  return mutation
}
